<template>
	<el-drawer :title="formData.id ? '编辑track渠道' : '新增track渠道'"  :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true"
		size="400px" @close="close">
		<div class="drawer-content">
			<el-form :model="formData" ref="formData" label-position="top" :rules="rules" v-loading="dataLoading">
				<el-form-item prop="name">
					<span slot="label">渠道名称：</span>
					<el-input v-model="formData.name" maxlength="30"></el-input>
				</el-form-item>
				<el-form-item prop="track">
					<span slot="label">track参数：</span>
					<el-input v-model="formData.track" maxlength="20" :disabled="formData.id ? true: false"></el-input>
				</el-form-item>
				<el-form-item prop="activityId" label="跟踪演出解析:">
					<el-select v-model="formData.activityId" value-key="value" :filterable="true" :remote="true"
						:remote-method="remoteShow" :loading="remoteLoading" placeholder="请填写演出ID搜索"  :disabled="formData.id ? true: false">
						<el-option v-for="item in remoteOptions" :key="item.value"
							:label="item.value + '-' + item.label" :value="item.value"></el-option>
					</el-select>

				</el-form-item>
				<el-form-item prop="commission">
					<span slot="label">渠道佣金：</span>
					<el-input-number v-model="formData.commission" style="width: 100%;" controls-position="center"
						:min="0" :max="100" size="medium" placeholder="只能输入【0,100】的数字"></el-input-number>
				</el-form-item>

			</el-form>
		</div>
		<div class="drawer-footer">
			<el-button @click="close">关闭</el-button>
			<el-button type="primary" :loading="btnLoading" @click="submitForm()">确认</el-button>
		</div>
	</el-drawer>
</template>
<script>
	const defaultFormData = {
		id: '',
		name: '',
		track: '',
		activityId: '',
		commission: ''
	}
	const validateTrack = (rule, value, callback) => {
		const _reg = /^[A-Za-z0-9]*$/;
		if (!_reg.test(value)) {
			callback(new Error("track参数只能是数字或字母"));
		} else {
			callback();
		}
	}
	export default {
		data() {
			return {
				formData: {
					...this.defaultFormData
				},
				rules: {
					name: [{
						required: true,
						message: "请填写渠道名称"
					}, ],
					activityId: [{
						required: true,
						message: "请解析演出"
					}, ],
					track: [{
							required: true,
							message: "请填写track参数"
						},
						{
							validator: validateTrack
						},
					],

				},
				drawerShow: false,
				dataLoading: false,
				btnLoading: false,
				remoteLoading: false,
				remoteOptions: [],
				
			}
		},
		methods: {
			show(data) {
				this.drawerShow = true;
				if(data){					
				    this.formData = {
				        ...defaultFormData,
				        ...data,
						commission:parseFloat(data.commission.replace('%', ''))
				    }
				}
			},
			close() {
				this.formData = {
					...defaultFormData
				};
				this.drawerShow = false;
			},

			// 演出
			async remoteShow(id) {
				this.remoteLoading = true;
				const res = await this.$request({
					url: '/msg/push/check/activity',
					method: 'post',
					params: {
						id
					}
				}).catch(() => {
					return {
						data: {
							state: '0',
							msg: '请求错误'
						}
					};
				}).finally(() => {
					this.remoteLoading = false;
				});

				const {
					state,
					result
				} = res.data;

				if (state !== '1') {
					this.remoteOptions = [];
					return;
				}

				const {
					name,
					cityCodeAndNameVo: {
						cityName,
						cityCode
					}
				} = result;

				this.remoteOptions = [{
					label: name,
					value: id,
					labelTips: `演出场地：${cityName}`,
					cityCodeList: [cityCode]
				}];
			},

			//表单提交
			submitForm() {
				this.$refs["formData"].validate(async (valid) => {
					if (valid) {
						this.btnLoading = true;
						this.$request({
								url: "/track/management/edit",
								method: "POST",
								data: {
									...this.formData,

								},
							})
							.then((res) => {
								const {
									state,
									msg
								} = res.data;
								if (state == 1) {
									this.$emit('onUpdate');
									this.close();
								} else {
									this.$message.error(msg || "请求失败");
								}
							})
							.catch(() => {
								this.$message.error("请求错误");
							})
							.finally(() => {
								this.btnLoading = false;
							});
					} else {
						return false;
					}
				})
			}
		}
	}
</script>
<style lang="scss" scoped>

</style>